import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogService } from '@app/core';
import { PricingContactSalesDialogComponent } from '../pricing-contact-sales-dialog/pricing-contact-sales-dialog.component';

@Component({
  selector: 'app-pricing-hero-section',
  imports: [],
  templateUrl: './pricing-hero-section.component.html',
  styleUrl: './pricing-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingHeroSectionComponent {
  private readonly dialogService = inject(DialogService);

  protected async handleContactSales(): Promise<void> {
    await this.dialogService.showComponentDialog(
      PricingContactSalesDialogComponent,
    );
  }
}
